import {Page} from '../types';

// Pages that render inside PortalLayout (its own MinimalNavHeader and auth
// providers) instead of the marketing NavHeader/Footer. Must match the
// src/pages files that use PortalLayout — portalPages.test.ts enforces it.
export const PORTAL_PAGES: readonly Page[] = [
  'sign-up',
  'sign-up-parent',
  'sign-in-parent',
  'reset-password',
  'parent-home',
  'parent-home/purchase-successful',
  'parent-home/invite-teen',
  'parent-home/add-daughter',
  'get-started',
];

export function isPortalPage(page: Page): boolean {
  return PORTAL_PAGES.includes(page);
}
